/**
 * @description
 * @author librajt
 */

import Api from '../../path';
import { fetchData } from '@umu/umu-fetch';

export interface IInput {
    parent_id: number;
    parent_type: number;
    question_id?: number;
}

export interface IOutput {
    word: string;
    count: number;
}

export const getFenciList = (data: IInput): Promise<IListResponse<IOutput>> => {
    return fetchData(Api.GET_FENCI, data).then((res: IListResponse<IOutput>) => {
        return res;
    });
};
